import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, UrlTree } from '@angular/router';
import { catchError, from, map, Observable, of } from 'rxjs';
import { DatabaseCacheService } from '../../data/cache/database-cache.service';
import { StoreAuthService } from '../auth/store-auth.service';

@Injectable()
export class SectionGroupAdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private storeAuth: StoreAuthService,
    private common: DatabaseCacheService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.checkPermission(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.checkPermissionChild(route, state);
  }

  
  checkPermission(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {

    if (this.common.doesSystemAdminKeyExist() ){
      if(this.isAdminHomeAccessible()){
        return of(true);
      }
    }

    return from(this.common.setLoginUser()).pipe(
      map(data => {

        if(!this.common.doesSystemAdminKeyExist()){
          // High security: return 404 for all admin errors (prevents route enumeration)
          this.router.navigate(['/not-found']);
          return false;
        }

        let sysAdmin = this.common.getSystemAdmin();
    
        if(this.isAdminHomeAccessible()){
          return true;
        }
        
        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/not-found']);
        return of(false);
      })
    );
    
  }

  isAdminHomeAccessible(){
    let sysAdmin = this.common.getSystemAdmin();
    // システム管理者として ALL_SECTION_GROUP_ADMIN を持っているときは アクセス可能
    if (sysAdmin != null){
      if(this.common.hasAllSectionGroupManagement()){
        return true;
      }
    }    

    // 対象のSectionGroup に対して SectionGroupAdmin を持っているときはアクセス可能
    let sgAdmins = this.common.getSectionGroupAdmins();
    if(sgAdmins.length > 0){
      return true;
    }

    return false;
  }

  
  checkPermissionChild(  
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) :boolean {

      
    let sectionGroupId = next.paramMap.get('sectionGroupId');

    if (state.url.indexOf('sections') > 0){
      if(this.common.hasAllSectionGroupManagement() || this.common.hasSectionManagement(sectionGroupId)){
        return true;
      }
      else{
        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }
    }

    if (state.url.indexOf('admins') > 0){
      if(this.common.hasAllSectionGroupManagement() || this.common.hasSectionGroupAdminManagement(sectionGroupId)){
        return true;
      }
      else{
        // High security: return 404 for all admin errors (prevents route enumeration)
        this.router.navigate(['/not-found']);
        return false;
      }
    }

    if (state.url.indexOf('monthly-summaries') > 0){
      return true;
    }

    // Allow 'home' route for section group admin
    if (state.url.includes('/home') || state.url.match(/\/section-group-admin\/[^\/]+$/)) {
      return true;
    }

    // Allow legal pages
    if (state.url.indexOf('tou') > 0 || state.url.indexOf('privacy') > 0 || state.url.indexOf('license') > 0) {
      return true;
    }

    if (state.url.indexOf('build-info') > 0){
      return true;
    }

    // High security: return 404 for all admin errors (prevents route enumeration)
    this.router.navigate(['/not-found']);
    return false;
  }

  // private isChildRoute(url: string): boolean {
  //   const currentConfig = this.router.config.find(r => r.path === '');
  //   const childRoutes = currentConfig?.children || [];
  //   return childRoutes.some(child => url.includes(child.path));
  // }

}
